import Vue from 'vue';
import { contractBoardName } from '../../constant/common-type';
import contractView from '../../components/contract/contract-view.vue';
export default Vue.extend({
    name: 'contractBoard',
    components: {
        'el-contract-view': contractView,
    },
    data: function () {
        return {
            dialogFormVisible: false,
            contractBoardName: contractBoardName,
        };
    },
    methods: {
        toContractDetail: function (contractCode) {
            this.$store.dispatch('contract/GET_CONTRACTDETAIL', {
                contractCode: contractCode,
                type: 'view',
            });
        },
        shut: function () {
            this.dialogFormVisible = false;
        },
    },
    props: {
        detail: {
            type: Object,
            default: function () {
                return {
                    list: [],
                };
            },
        },
        flag: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
        border: {
            type: Boolean,
            default: false,
        },
        isUseDetail: {
            type: Boolean,
            default: false,
        },
        isDialogContract: {
            type: Boolean,
            default: false,
        },
    },
});
